module.exports = __webpack_public_path__ + "img/firefox.a1be8be2.png";